// Angular imports
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

// 3rd pary imports
import { classToPlain, plainToClass } from 'class-transformer';

// CC-Common imports
import { CCLocalStorageCategory, CCLocalStorageService } from 'cc-common';

// Model imports
import { LiteModeEntry } from '../../_models/lite-mode-entry';
import { CacheDuration } from '../../_constants/cache-duration';

@Component({
    selector: 'app-lite-mode-preference',
    templateUrl: './lite-mode-preference.component.html',
    styleUrls: ['./lite-mode-preference.component.scss']
})
export class LiteModePreferenceComponent implements OnInit {
    @Input() title = 'Lite Mode Preference Changed';
    @Input() message: string;
    @Input() pageName: string;
    @Input() storageKey: string;
    @Input() defaultMode: boolean;
    @Output() onLoad: EventEmitter<boolean> = new EventEmitter();
    @Output() onChanged: EventEmitter<void> = new EventEmitter();

    visible = false;
    doNotPrompt = false;
    liteModeFlag = false;
    preference: LiteModeEntry;

    constructor(private readonly localStorageService: CCLocalStorageService) {
        this.onSaveClick = this.onSaveClick.bind(this);
        this.onCancelClick = this.onCancelClick.bind(this);
    }

    ngOnInit(): void {
        this.populatePreferences();
        this.onLoad.emit(this.preference.liteMode);
    }

    show(liteModeFlag: boolean): void {
        this.liteModeFlag = liteModeFlag;
        this.populatePreferences();
        if (this.preference.doNotPrompt) {
            if (!this.preference.doNotUpdate) {
                this.onSaveClick();
            }
            this.onChanged.emit();
        } else if (liteModeFlag !== this.preference.liteMode) {
            this.visible = true;
        }
    }

    hide(): void {
        this.visible = false;
        this.onChanged.emit();
    }

    onShown(e: any): void {
        e.component.repaint();
    }

    onSaveClick(): void {
        this.preference.liteMode = this.liteModeFlag;
        this.preference.doNotUpdate = false;
        this.persistPreference();
        this.hide();
    }

    onCancelClick(): void {
        if (this.doNotPrompt) {
            this.preference.doNotPrompt = this.doNotPrompt;
            this.preference.doNotUpdate = true;
            this.persistPreference();
        }
        this.hide();
    }

    private populatePreferences(): void {
        this.preference = plainToClass(
            LiteModeEntry,
            JSON.parse(
                this.localStorageService.getItem(this.storageKey, CCLocalStorageCategory.LITE) ||
                    JSON.stringify(new LiteModeEntry(this.defaultMode))
            )
        );
        if (this.preference.isExpired(CacheDuration.oneDay)) {
            this.preference.doNotPrompt = false;
        }
        this.doNotPrompt = this.preference.doNotPrompt;
    }

    private persistPreference(): void {
        this.preference.doNotPrompt = this.doNotPrompt;
        this.localStorageService.setItem(
            this.storageKey,
            JSON.stringify(classToPlain(this.preference)),
            CCLocalStorageCategory.LITE
        );
    }
}
